export default __webpack_public_path__ + "static/media/4.e605243b.webp";